const tituloDeId = (id, data) => {
  const selectedTitle = data.find((item) => item.ID === id);
  return selectedTitle ? selectedTitle.title : id;
};

export const IdToTitle = ({ id, data }) => {
  if (Array.isArray(id)) {
    return <>{id.map((unId) => tituloDeId(unId, data)).join(", ")}</>;
  }

  return <>{tituloDeId(id, data)}</>;
};
